<template>
    <v-container class="px-0" fluid v-show="innerShouldShow">
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                :vid="'validate-' + fieldAssignmentId"
            >
                <h3 v-if="directions">{{ directions }}</h3>
                <v-radio-group v-model="innerValue">
                    <div
                        v-for="(n, i) in innerValueOptions"
                        :class="[
                            'mb-3 text-capitalize checkbox-new radio-new',
                            innerValue === n.id ? 'selected' : null
                        ]"
                        :key="i"
                    >
                        <v-radio
                            v-bind="vProps"
                            :value="n.id"
                            :label="n.name"
                            :error-messages="errors"
                        ></v-radio>
                    </div>
                </v-radio-group>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="reviewValue">
                    <p v-html="reviewValue"></p>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </v-container>
</template>

<script>
import TypeReview from './TypeReview';
import formMixin from '../formMixin';

export default {
    name: 'TypeRedemptionFrequency',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        reviewValue() {
            let v = this.innerValueOptions.find(x => x.id === this.innerValue);
            return (v && v.name) || null;
        },
        innerValueOptions() {
            const options = [];
            if (this.settings.single_use)
                options.push({ id: '0_1_month', name: 'Single-Use' });

            if (this.settings.repeat) {
                options.push({ id: '1_1_days', name: 'Repeat once daily' });
                options.push({
                    id: '1_1_weeks',
                    name: 'Repeat once a week'
                });
                options.push({
                    id: '1_1_months',
                    name: 'Repeat once a month'
                });
            }
            return options;
        },
        rules() {
            return (!this.vProps.readonly || !this.vProps.disabled) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        }
    }
};
</script>

<style lang="scss">
// TODO: this should be set globally
.radio-new {
    .v-label {
        margin: 0;
    }
}
</style>
